import { PayloadType, UserStateType } from "@/common/types";
import Types from "../types";

const usersInitialState: UserStateType = {
  usersList: [],
  doctors: [],
  patients: [],
  doctorDetails: null,
  patientDetails: null,
  medicalHistory: null,
};

export const usersReducer = (
  state = usersInitialState,
  action: PayloadType
) => {
  switch (action.type) {
    case Types.SET_USERS:
      return {
        ...state,
        usersList: action.payload,
      };
    case Types.SET_DOCTORS:
      return {
        ...state,
        doctors: action.payload,
      };
    case Types.SET_PATIENTS:
      return {
        ...state,
        patients: action.payload,
      };
    case Types.SET_DOCTOR_DETAILS:
      return {
        ...state,
        doctorDetails: action.payload,
      };
    case Types.SET_PATIENT_DETAILS:
      return {
        ...state,
        patientDetails: action.payload,
      };
    case Types.SET_MEDICAL_HISTORY:
      return {
        ...state,
        medicalHistory: action.payload,
      };
    default:
      return state;
  }
};
